import React from 'react';
import loadable from '@loadable/component';
// eslint-disable-next-line @nx/enforce-module-boundaries
import GlobalNav from '@99designs/site-navigation/components/GlobalNav/GlobalNav';
// eslint-disable-next-line @nx/enforce-module-boundaries
import SiteFooter from '@99designs/site-navigation/components/SiteFooter/SiteFooter';
// eslint-disable-next-line @nx/enforce-module-boundaries
import SiteHeader from '@99designs/site-navigation/components/SiteHeader/SiteHeader';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { Role } from '@99designs/site-navigation/consts';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { Site } from '@99designs/site-navigation/lib/Site';
import { Loading } from '@99designs/spa-common';
import { getNavigationRole, useViewer } from '@99designs/viewer';

type FooterStyle = 'focused' | 'reduced' | 'full';

const Drawers = loadable(
    () => import('@99designs/site-navigation/components/GlobalNavDrawers/GlobalNavDrawers')
);

interface LayoutProps {
    role?: Role;
    site: Site;
    children: React.ReactNode;
    footerStyle?: FooterStyle;
}

function Layout({ children, role, site, footerStyle = 'focused' }: LayoutProps) {
    const viewer = useViewer();
    const navRole = !role ? getNavigationRole(viewer) : role;

    return (
        <GlobalNav>
            {({ toggleDrawer, drawerState }) => (
                <>
                    <SiteHeader
                        role={navRole}
                        site={site}
                        variations={['gradient']}
                        onLeftDrawerTriggerClick={toggleDrawer('left', true)}
                        onRightDrawerTriggerClick={toggleDrawer('right', true)}
                    />
                    {children}
                    <Drawers
                        toggleDrawer={toggleDrawer}
                        role={navRole}
                        site={site}
                        drawerState={drawerState}
                        fallback={<Loading />}
                    />
                    <SiteFooter
                        site={site}
                        isFocused={footerStyle === 'focused'}
                        isReduced={footerStyle === 'reduced'}
                        // full footer doesn't require anything to be set, it's the default
                    />
                </>
            )}
        </GlobalNav>
    );
}

export default Layout;
